/*
* 店铺签名设置
* */

// import { get, post, postJson } from './axios'

// const RESOURCE_BASE_PATH = '/smsBlackList'

// //  批量插入黑名单
// export const insertBlack = p => post(`${RESOURCE_BASE_PATH}/insert`, p);





import { get, post, postJson, deleteApi, deleteApiJson, imagePost} from './axios'

const RESOURCE_BASE_PATH = '/smsBlackList'

const RESOURCE_BASE_PATH2 = '/Upload-file'

// 删除黑名单
export const delSmsBlackList = p => deleteApiJson(`${RESOURCE_BASE_PATH}/delSmsBlackList`, p);

// 按查询删除黑名单
export const delSmsBlackListBySelect = p => get(`${RESOURCE_BASE_PATH}/delSmsBlackListBySelect`, p);

// 导出黑名单
export const exportBlack = p => post(`${RESOURCE_BASE_PATH}/export`, p);

//  批量插入黑名单
export const insertBlack = p => postJson(`${RESOURCE_BASE_PATH}/insert`, p);

// 查询会员人群
export const listBlack = p => get(`${RESOURCE_BASE_PATH}/list`, p);

//导入黑名单
// export const importBlack = p => post(`${RESOURCE_BASE_PATH2}/uploadBlackList`, p); 
export const importBlack = p => imagePost(`${RESOURCE_BASE_PATH2}/uploadBlackList`, p); 

// 查询手机号或买家账号明文
export const blackDetail = p => get(`${RESOURCE_BASE_PATH}/detail`, p);

// 导出接口定义
export const blackExport = p => get(`/smsBlackList/export`, p);


